import { sendErrorTrace, sendTrace } from './lib/sendTrace';
var Stacktrace = /** @class */ (function () {
    /**
     *
     * @param data
     */
    function Stacktrace() {
        // avoid double registration
        // if ((window as any).__error_handling) {
        //   return
        // }
        // (window as any).__error_handling = true
        window.onerror = function (message, source, lineno, colno, error) {
            var err = error;
            if (!err) {
                err = {
                    message: message || '',
                    name: 'ERROR',
                    stack: 'NO_STACK_AVAILABLE',
                };
            }
            sendErrorTrace({
                error: err,
                data: {
                    path: window.location.pathname,
                    source: source || '',
                    line: lineno || '',
                    message: message || '',
                    colno: colno || '',
                },
            });
            // When the function returns true, this prevents the firing of the default event handler.
            return false;
        };
        // window.onunhandledrejection = event => {
        //   console.warn(`UNHANDLED PROMISE REJECTION: ${event.reason}`, event);
        // }
    }
    /**
     * Send error trace
     */
    Stacktrace.prototype.send = function (conf) {
        if (conf && conf.error) {
            return sendErrorTrace({ error: conf.error, data: conf.data || {} });
        }
        else if (conf) {
            return sendTrace({ name: conf.name || 'DEFAULT_LOG', data: conf.data || {} });
        }
        else {
            return sendTrace({ name: 'DEFAULT_LOG', data: {} });
        }
    };
    return Stacktrace;
}());
export default Stacktrace;
//# sourceMappingURL=Jslog.js.map